import React from 'react';
import { Add, DeleteForever, Brush, Colorize, Filter, Forum, Undo, Publish, FormatColorFill } from '@mui/icons-material';
import '../component.css';

function Icon({name}) {
    switch (name) {
        case "add":     return <Add fontSize="small"/>;
        case "clear":   return <DeleteForever style={{fontSize: 22}}/>;
        case "pen":     return <Brush fontSize="small"/>;
        case "pipette": return <Colorize fontSize="small"/>;
        case "layer":   return <Filter fontSize="small"/>;
        case "bucket":  return <FormatColorFill fontSize="small"/>;
        case "chat":    return <Forum fontSize="small"/>;
        case "erase":   return <span className="material-symbols-outlined" style={{fontSize: 20, fontVariationSettings: "'wght' 600"}}>ink_eraser</span>;
        case "plus":    return <Add fontSize="small"/>;
        case "remove":  return <DeleteForever style={{fontSize: 22}}/>;
        case "undo":    return <Undo fontSize="small"/>;
        case "publish": return <Publish fontSize="small"/>;
        default:        return null;
    }
}

export default function SquareButton({icon, onClick, selected, secondary}) {
    let cls = 'sq-btn';
    if (selected) cls += ' sq-btn--selected';
    if (secondary) cls += ' sq-btn--secondary';

    return (
        <button className={cls} onClick={onClick}>
            <Icon name={icon}/>
        </button>
    );
}
